import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { images } from '../constants'

const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: auto;
  background-image: linear-gradient(to right, var(--grey) 0%, var(--grey) 50%, var(--black-medium) 50%, var(--black-medium) 100%);
  @media screen and (max-width: 800px) {
    background-image: none;
  }
`
const ImageWrapper = styled.section`
  position: absolute;
  z-index: 0;
  top: 0;
  width: 100%;
  height: 440px;
  background-repeat: no-repeat;
  background-position: calc(50% - 270px) 0;
  background-size: 440px 440px;
  background-image: url(${images.profile});

  @media screen and (max-width: 1023px) {
    background-position: calc(50% - 320px) 0;
  }
  @media screen and (max-width: 800px) {
    background-position: right 0;
    background-color: var(--grey);
  }
`
const SectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 86%;
  max-width: var(--max-width);
  height: 440px;
  margin: 0 auto;
  @media screen and (max-width: 800px) {
    flex-direction: column;
    width: calc(100% - 50px);
    margin: 0 25px;
    height: auto;
  }
`
const LeftColumn = styled.div`
  width: calc(50% - 50px);
  position: relative;
  z-index: 1;
  h5 {
    position: absolute;
    bottom: 12px;
    right: 13px;
    color: var(--grey);
    font-size: var(--fz-xxs);
  }
  @media screen and (max-width: 1023px) {
    width: calc(50% - 100px);
  }
  @media screen and (max-width: 800px) {
    height: 440px;
    width: 100%;
    h5 {
      right: 0;
    }
  }
`
const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: flex-start;
  width: calc(50% + 50px);
  padding: 0 0 0 50px;
  background-color: var(--black-medium);
  h2 {
    margin-bottom: 15px;
  }
  p {
    color: var(--text);
  }
  .button {
    margin: 30px 0 0 0;
  }
  @media screen and (max-width: 1023px) {
    width: calc(50% + 100px);
    padding: 0 0 0 40px;
  }
  @media screen and (max-width: 800px) {
    width: calc(100% + 50px);
    margin-left: -25px;
    padding: 70px 25px 90px;
  }
`

const HomeAbout = () => {
  const handleLinkClick = () => {
    window.dataLayer.push({ event: 'btn_work_with_me' })
  }

  return (
    <SectionWrapper>
      <SectionContainer className="sequence">
        <LeftColumn />
        <RightColumn>
          <h2>Introducing your expert, Robert Eberhard</h2>
          <p>For over 20 years, Robert has been providing website and application development and design services to clients ranging from multinational corporations to small independent businesses and creatives. He approaches each project with the same level of attention to detail, converting design to code in an efficient and effective manner. Robert values open communication and strives to provide clients with the highest quality of service.</p>
          <Link onClick={handleLinkClick} to="/contact" className="button item">
            Work with me
          </Link>
        </RightColumn>
      </SectionContainer>
      <ImageWrapper />
    </SectionWrapper>
  )
}

export default HomeAbout
